import React from 'react';
import { motion } from 'framer-motion';
import { useAnimateOnScroll } from '../hooks';

// Importing icons from react-icons
import { FiMail, FiGithub, FiMapPin } from 'react-icons/fi';
import { FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';

const contactLinks = [
  {
    protocol: 'MAIL',
    label: 'EMAIL',
    icon: <FiMail size={18} className="text-zinc-400 group-hover:text-white transition-colors" />,
    text: 'sufiyanpk67@gmail.com',
    href: 'mailto:sufiyanpk67@gmail.com'
  },
  {
    protocol: 'HTTPS',
    label: 'GITHUB_REPOS',
    icon: <FiGithub size={18} className="text-zinc-400 group-hover:text-white transition-colors" />,
    text: 'github.com/sufiyanpk7',
    href: 'https://github.com/sufiyanpk7'
  },
  {
    protocol: 'HTTPS',
    label: 'LINKEDIN_PROF',
    icon: <FaLinkedinIn size={18} className="text-zinc-400 group-hover:text-white transition-colors" />,
    text: 'sufiyan-pk',
    href: 'https://www.linkedin.com/in/sufiyanpk/'
  },
  {
    protocol: 'WHATSAPP',
    label: 'SEND_MESSAGE',
    icon: <FaWhatsapp size={18} className="text-zinc-400 group-hover:text-white transition-colors" />,
    text: '+91 9745821550',
    href: 'https://wa.me/919745821550'
  },
  {
    protocol: 'LOCATION',
    label: 'LOCATION',
    icon: <FiMapPin size={18} className="text-zinc-400 group-hover:text-white transition-colors" />,
    text: 'Abu Dhabi, UAE',
    href: ''
  }
];

const Contact: React.FC = () => {
  const { ref, inView } = useAnimateOnScroll();

  return (
    <section id="contact" className="py-16 sm:py-20 bg-[#050505] px-4 sm:px-8 md:px-12 border-t border-zinc-900 overflow-hidden">
      <div className="max-w-4xl mx-auto" ref={ref}>
        
        {/* Main Section Heading */}
        <div className="mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-mono font-medium text-white tracking-tight mb-2">
            ~/Contact
          </h2>
          <div className="text-zinc-500 font-mono text-xs sm:text-sm tracking-widest uppercase">
            05 // Contact Endpoints
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          {/* Terminal Intro Text */}
          <div className="mb-8 font-mono text-xs sm:text-sm text-zinc-400 border-l-2 border-zinc-800 pl-4 py-1">
            <span className="text-zinc-600 select-none mr-2">{'>'}</span>
            Awaiting transmission for DevSecOps, Platform Engineering, and AI Infrastructure roles.
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {contactLinks.map((link, index) => {
              // Check if it is the last item and if the total number of items is odd
              const isLastOdd = index === contactLinks.length - 1 && contactLinks.length % 2 !== 0;

              return (
                <motion.a
                  key={link.label}
                  initial={{ opacity: 0, x: -10 }}
                  animate={inView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  href={link.href || undefined}
                  target={link.href && link.href.startsWith('http') ? '_blank' : undefined}
                  rel={link.href && link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className={`group flex flex-col justify-center bg-[#0a0a0a] border border-zinc-800/80 px-5 py-4 hover:border-zinc-500 hover:bg-zinc-900/30 transition-all duration-300 w-full ${
                    isLastOdd ? 'md:col-span-2 md:w-[calc(50%-0.5rem)] md:mx-auto' : ''
                  }`}
                >
                  {/* Protocol Header */}
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-mono text-[10px] text-zinc-500 tracking-widest uppercase">
                       // {link.label}
                    </span>
                    {link.icon}
                  </div>
                  
                  {/* Contact Value */}
                  <span className="font-mono text-sm sm:text-base text-zinc-300 group-hover:text-white transition-colors">
                    {link.text}
                  </span>
                </motion.a>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;